export type ThemeName = "light" | "dark";

export type Palette = {
  water: string;
  land: string;
  landTint: string;
  coastline: string;
  coastlineWidth: number;
  motorway: string;
  motorwayCasing: string;
  motorwayWidth: number;
  secondary: string;
  secondaryWidth: number;
  builtUp: string;
  builtUpMajor: string;
  grid: string;
  cityLabel: string;
  cityLabelHalo: string;
  capitalLabel: string;
  target: string;
  targetMajor: string;
  targetCapital: string;
  targetDead: string;
  targetMarker: string;
  fixed: string;
  mobile: string;
  sensor: string;
  weapon: string;
  weaponHidden: string;
  hull: string;
  intercept: string;
  interceptMiss: string;
  impact: string;
  rangeFixed: string;
  rangeMobile: string;
  rangeSensor: string;
  missile: string;
  missileTrail: string;
};

const LIGHT: Palette = {
  water: "#a4cad9",
  land: "#f3ecdb",
  landTint: "#e8dfc5",
  coastline: "#806e4d",
  coastlineWidth: 1.4,
  motorway: "#fcb070",
  motorwayCasing: "#c97f3f",
  motorwayWidth: 3.0,
  secondary: "#ffffff",
  secondaryWidth: 1.6,
  builtUp: "rgba(196, 178, 144, 0.55)",
  builtUpMajor: "rgba(170, 145, 110, 0.65)",
  grid: "rgba(120, 100, 70, 0.04)",
  cityLabel: "#2c2519",
  cityLabelHalo: "rgba(243, 236, 219, 0.95)",
  capitalLabel: "#1c1810",
  target: "#7a3a1d",
  targetMajor: "#923514",
  targetCapital: "#a3260a",
  targetDead: "#7a6e58",
  targetMarker: "#3a2d18",
  fixed: "#1f4795",
  mobile: "#1d6b3f",
  sensor: "#5a5246",
  weapon: "#c0392b",
  weaponHidden: "#8a5a4a",
  hull: "rgba(0, 0, 0, 0.55)",
  intercept: "#1d6b3f",
  interceptMiss: "#c79a3b",
  impact: "#c0392b",
  rangeFixed: "rgba(31, 71, 149, 0.13)",
  rangeMobile: "rgba(29, 107, 63, 0.13)",
  rangeSensor: "rgba(90, 82, 70, 0.10)",
  missile: "#1c1c1c",
  missileTrail: "rgba(40, 40, 40, 0.55)",
};

const DARK: Palette = {
  water: "#021022",
  land: "#0a1f33",
  landTint: "#0d2840",
  coastline: "#3b5878",
  coastlineWidth: 1.2,
  motorway: "#e8a04a",
  motorwayCasing: "#7a4a18",
  motorwayWidth: 2.6,
  secondary: "#3c5876",
  secondaryWidth: 1.2,
  builtUp: "rgba(56, 117, 246, 0.07)",
  builtUpMajor: "rgba(56, 117, 246, 0.14)",
  grid: "rgba(56, 117, 246, 0.05)",
  cityLabel: "#e6edf6",
  cityLabelHalo: "rgba(2, 16, 34, 0.85)",
  capitalLabel: "#ffffff",
  target: "#f0c674",
  targetMajor: "#f5a85a",
  targetCapital: "#ff9a3c",
  targetDead: "#5a4a30",
  targetMarker: "rgba(0, 0, 0, 0.55)",
  fixed: "#3875F6",
  mobile: "#6cd99f",
  sensor: "#8aa2b8",
  weapon: "#ef6868",
  weaponHidden: "#7a3a3a",
  hull: "rgba(0, 0, 0, 0.55)",
  intercept: "#6cd99f",
  interceptMiss: "#f0c674",
  impact: "#ef6868",
  rangeFixed: "rgba(56, 117, 246, 0.10)",
  rangeMobile: "rgba(108, 217, 159, 0.07)",
  rangeSensor: "rgba(138, 162, 184, 0.08)",
  missile: "#e9f4ff",
  missileTrail: "rgba(233, 244, 255, 0.55)",
};

export function getPalette(theme: ThemeName): Palette {
  return theme === "light" ? LIGHT : DARK;
}
